import { Specializations } from './Specializations';
export class SectorUpdatedModel {
    id: number;
    nameEn: string;
    nameFr: string;
    SpecializationsToDeleted: number[] = [];
    specializations: Specializations[] = [];
}
